export default __webpack_public_path__ + "static/media/internet_sites.9d019e60.csv";